import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"
import { MAIN_API_BASE } from "./apiConfig";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const resolveImageUrl = (img, folder = 'property_images') => {
  if (!img || typeof img !== 'string') return '';
  const trimmed = img.trim();
  if (!trimmed || trimmed === 'NULL' || trimmed === 'null') return '';

  const filename = trimmed.split('?')[0].split('#')[0].split('/').pop();
  if (!filename) return '';

  return `${MAIN_API_BASE}/storage/${folder}/${filename}`;
};
